"use client";

import React, { useState, useEffect } from 'react';
import { useStore } from '@/context/StoreContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export default function WhatsAppFloat() {
    const { settings } = useStore();
    const [showTooltip, setShowTooltip] = useState(false);
    const [hasInteracted, setHasInteracted] = useState(false);

    const widgetConfig = settings.whatsapp_widget;
    
    // Telefone prioritário: widget > configurações gerais
    const rawPhone = widgetConfig?.phone || settings.phone;
    const isExplicitlyDisabled = widgetConfig?.is_active === false;

    // Mensagem padrão amigável
    const message = widgetConfig?.message || 'Olá! Estava navegando no catálogo e gostaria de tirar uma dúvida.';
    const callToAction = widgetConfig?.call_to_action || 'Fale com a gente';

    useEffect(() => {
        if (!isExplicitlyDisabled && rawPhone) {
            const timer = setTimeout(() => {
                setShowTooltip(true);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isExplicitlyDisabled, rawPhone]);

    if (isExplicitlyDisabled || !rawPhone) {
        return null;
    }

    const cleanPhone = rawPhone.replace(/\D/g, '');
    if (!cleanPhone) return null;

    // URL oficial do WhatsApp com mensagem codificada
    const whatsappUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;

    const positionClass = widgetConfig?.position === 'left' ? 'left-5' : 'right-5';

    return (
        <div className={`fixed bottom-6 ${positionClass} z-40 flex items-end gap-3 select-none print:hidden`}>
            {/* Balão de Mensagem / Tooltip */}
            {showTooltip && !hasInteracted && (
                <div className="hidden sm:flex items-center gap-2 bg-white text-gray-800 text-xs md:text-sm font-semibold py-2.5 px-4 rounded-2xl shadow-xl border border-gray-100 animate-fadeIn mb-1">
                    <span>{callToAction}</span>
                    <button 
                        type="button" 
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowTooltip(false);
                            setHasInteracted(true);
                        }}
                        className="text-gray-400 hover:text-gray-600 p-0.5 ml-1 transition-colors"
                        aria-label="Fechar balão"
                    >
                        <FontAwesomeIcon icon={faXmark} className="w-3 h-3" />
                    </button>
                </div>
            )}

            {/* Botão Flutuante */}
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setHasInteracted(true)}
                className="group relative flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-[#25D366]/40 hover:scale-110 active:scale-95 transition-all duration-300"
                aria-label="Abrir WhatsApp"
                title="Atendimento via WhatsApp"
            >
                {/* Efeito de Pulso Sutil */}
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 group-hover:opacity-40 pointer-events-none"></span>
                
                <FontAwesomeIcon icon={faWhatsapp} className="text-3xl relative z-10 transition-transform group-hover:rotate-6" />

                {/* Badge de Ativo (Ponto Verde Claro) */}
                <span className="absolute top-1 right-1 w-3.5 h-3.5 bg-white rounded-full flex items-center justify-center shadow">
                    <span className="w-2.5 h-2.5 bg-emerald-500 rounded-full animate-pulse"></span>
                </span>
            </a>
        </div>
    );
}
